var addOutline = "https://shopfront-cdn.tekoapis.com/static/949377dd1535d300.svg";

export { addOutline as default };
